import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-brand-ivory text-center text-brand-text text-xs sm:text-sm border-t border-brand-cream" data-id="element-67">
      <p className="leading-relaxed max-w-2xl mx-auto font-medium mb-4" data-id="element-68">
        © {new Date().getFullYear()} DANCE PRO™ — Tous droits réservés.
        <br data-id="element-69" />
        <br data-id="element-70" />
        Les informations présentées sur ce site sont destinées exclusivement à
        des fins pédagogiques et constituent une ressource professionnelle pour
        les professeurs et enseignants de danse. Elles ne remplacent ni votre
        jugement professionnel ni les recommandations pédagogiques de votre
        établissement, école ou organisme de formation. Utilisez toujours votre
        expertise afin d'adapter les contenus aux besoins et au niveau de vos
        élèves.
      </p>
      <div className="flex justify-center gap-3 sm:gap-4 font-bold tracking-wide uppercase text-brand-title" data-id="element-71">
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-72">
          Conditions Générales
        </a>
        <span data-id="element-73">·</span>
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-74">
          Politique de Confidentialité
        </a>
        <span data-id="element-75">·</span>
        <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-76">
          Contact
        </a>
      </div>
    </footer>;
}